module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onboarding_comp auth-input-page"
  }, [_c('div', {
    staticClass: "auth-input-page__group"
  }, [_c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("Full Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullName),
      expression: "fullName"
    }],
    class: {
      _filled: _vm.fullName
    },
    attrs: {
      "type": "text",
      "placeholder": "Your full name"
    },
    domProps: {
      "value": (_vm.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "auth-input-page__group my-1"
  }, [_c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: {
      _filled: _vm.email
    },
    attrs: {
      "type": "email",
      "placeholder": "Your email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "auth-input-page__group"
  }, [_c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Your password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    class: {
      'display-flex align-center gap-8 justify-space-between': _vm.$vuetify.breakpoint.width <= 1280,
    }
  }, [(_vm.$vuetify.breakpoint.width <= 1280) ? _c('v-btn', {
    staticClass: "back-button",
    on: {
      "click": function($event) {
        _vm.$emit('actionPrevStage')
      }
    }
  }, [_vm._v("\n      Back\n    ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "auth-button",
    class: {
      _disabled: !_vm.validated('skipToast'),
      'auth-bg-disabled': _vm.checkDataEmpty,
      'auth-bg-active': !_vm.checkDataEmpty,
    },
    on: {
      "click": function($event) {
        _vm.handleNextStage()
      }
    }
  }, [_vm._v("\n      Next\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a01bce68","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/auth/onboarding/accountInfo.vue
// module id = 1825
// module chunks = 180